import React from "react";
import styled from "styled-components";

import PropTypes from "prop-types";
import starFill from "../../../assets/images/icons/start-fill.svg";
import starEmpty from "../../../assets/images/icons/star-empty.svg";

const FeedbackRatingItem = styled.span`
  display: inline-block;
  margin: 0px 2px;
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
`;

const FeedbackRatingItemFill = styled(FeedbackRatingItem)`
  background-image: url("${starFill}");
`;

const FeedbackRatingItemEmpty = styled(FeedbackRatingItem)`
  background-image: url("${starEmpty}");
`;

const FeedbackRatingList = styled.div`
  width: 100%;
  text-align: ${({ $center }) => ($center ? "center" : "initial")};
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const FeedbackRating = ({ center = null, rating = null }) => {
  if (rating === 5.5) {
    return (
      <FeedbackRatingList $center={center}>
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
      </FeedbackRatingList>
    );
  }
  if (rating === 4.5) {
    return (
      <FeedbackRatingList $center={center}>
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemEmpty />
      </FeedbackRatingList>
    );
  }
  if (rating === 3.5) {
    return (
      <FeedbackRatingList $center={center}>
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
      </FeedbackRatingList>
    );
  }
  if (rating === 2.5) {
    return (
      <FeedbackRatingList $center={center}>
        <FeedbackRatingItemFill />
        <FeedbackRatingItemFill />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
      </FeedbackRatingList>
    );
  }
  if (rating === 1.5) {
    return (
      <FeedbackRatingList $center={center}>
        <FeedbackRatingItemFill />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
      </FeedbackRatingList>
    );
  }
  if (rating === 0.5) {
    return (
      <FeedbackRatingList $center={center}>
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
        <FeedbackRatingItemEmpty />
      </FeedbackRatingList>
    );
  }
  return (
    <FeedbackRatingList $center={center}>
      <FeedbackRatingItemFill />
      <FeedbackRatingItemFill />
      <FeedbackRatingItemFill />
      <FeedbackRatingItemFill />
      <FeedbackRatingItemFill />
    </FeedbackRatingList>
  );
};

FeedbackRating.propTypes = {
  center: PropTypes.bool,
  rating: PropTypes.number,
};

export default FeedbackRating;
